export default __webpack_public_path__ + "static/media/err-503.499b44c5.svg";